import * as themeServices from '../../services/themeServices';
import {
    START_LOADING,
    STOP_LOADING
} from "./actionTypes"
import { openSessionTimeoutModal } from './sessionTimeOutActions';
 
export const getThemeAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.getTheme(token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_THEME_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  }
};

export const getThemeSelectedLogoAction = (id) => async (dispatch, getState) => {
  
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.getSelectedThemLogo(id, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_THEME_SELECTED_LOGO_SUCCESS', payload: response });
    return response;
    
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_THEME_SELECTED_LOGO_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  }
};

export const getAllThemeAction = (callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.getAllTheme(token);
    if(response){
      callbackfn?.(response);
    }
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_ALL_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_ALL_THEME_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  }
};

export const setDefaultCustomerThemeAction = (themeid) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.setDefaultThemeService(themeid, token);  
    dispatch({ type: 'SET_CUSTOMER_DEFAULT_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SET_CUSTOMER_DEFAULT_THEME_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  }
};

export const saveThemeAction = (customTheme, user, selectedTheme, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'START_LOADING', service: 'SAVE_THEME' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await themeServices.saveTheme(
      customTheme,
      user,
      selectedTheme,
      token
    );

    if(response) {
      callbackfn?.();
      dispatch({ type: 'SAVE_THEME_SUCCESS', payload: response });
    }

  } catch (error) {
    if(error?.message?.includes("403") || error?.toString()?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({
        type: 'SAVE_THEME_FAILURE',
        payload: error?.message || 'Failed to save theme. Please try again.'
      });
    }
  } finally {
    dispatch({ type: 'STOP_LOADING', service: 'SAVE_THEME' });
  }
};

export const updateThemeAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'UPDATE_THEME' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.updateTheme(formData, token);
    dispatch({ type: STOP_LOADING, service: 'UPDATE_THEME' });
    if(response) {
      callbackfn();
    }
    dispatch({ type: 'UPDATE_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'UPDATE_THEME' });
      dispatch({ type: 'UPDATE_THEME_FAILUTE', payload: typeof(error)==="object" ? error.message : error || 'Update theme service failed. Please try again.' });
    }
  }
};